import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import DSDialog from "../system-design/DSDialog";
import DSDialogTitle from "../system-design/DSDialogTitle";
import DSDialogContent from "../system-design/DSDialogContent";
import DSIconButton from "../system-design/DSIconButton";
import Terms from "../Terms";

type TermsDialogProps = {
  open: boolean;
  onClose: () => void;
};

const TermsDialog = ({ open, onClose }: TermsDialogProps) => {
  return (
    <DSDialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      sx={{
        "& .MuiDialog-paper": {
          width: { xs: "100vw", md: "80vw" },
          height: { xs: "100vh", md: "80vh" },
          maxWidth: "none",
          maxHeight: "none",
          margin: { xs: 0, md: "auto" },
        },
      }}
    >
      <DSDialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          paddingRight: 1,
        }}
      >
        Terms and Conditions
        <DSIconButton onClick={onClose} size="small">
          <CloseIcon />
        </DSIconButton>
      </DSDialogTitle>
      <DSDialogContent
        sx={{
          padding: { xs: 2, md: 3 },
          overflow: "auto",
        }}
      >
        <Terms />
      </DSDialogContent>
    </DSDialog>
  );
};

export default TermsDialog;
